import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { getUserProfile } from '../services/ProfileService';
import { useAuthStore } from './authStore';

/**
 * Store para gestión de perfil de usuario
 * Separado de authStore para seguir el principio de responsabilidad única
 */
export const useProfileStore = create(
    devtools((set, get) => ({
        // State
        profile: null,
        isLoading: false,
        error: null,

        // Actualizar perfil en el estado
        setProfile: (profileData) => {
            set({ profile: profileData, error: null });
        },

        // Obtener perfil del backend
        fetchProfile: async () => {
            set({ isLoading: true, error: null });
            try {
                const response = await getUserProfile();
                const profileData = response.data;
                set({ profile: profileData, isLoading: false });

                const authStore = useAuthStore.getState();
                const currentUser = authStore.auth?.user;
                if (currentUser) {
                    authStore.updateUserProfile({
                        ...currentUser,
                        perfilUsuario: profileData,
                    });
                }
                
                // Actualizar también el localStorage para que persista al recargar
                const storageData = JSON.parse(localStorage.getItem('userDetails') || '{}');
                if (storageData.user) {
                    storageData.user = {
                        ...storageData.user,
                        ...currentUser,
                        perfilUsuario: profileData,
                    };
                    localStorage.setItem('userDetails', JSON.stringify(storageData));
                }
                
                return profileData;
            } catch (error) {
                console.error('Error al obtener el perfil:', error);
                set({
                    error: error.response?.data?.message || 'Error al cargar el perfil',
                    isLoading: false
                });
                throw error;
            }
        },

        // Actualizar campo específico del perfil
        updateProfileField: (field, value) => {
            const { profile } = get();
            if (!profile) return;

            set({
                profile: {
                    ...profile,
                    [field]: value
                }
            });
        },

        // Actualizar perfil completo
        updateProfile: (profileData) => {
            set({ profile: profileData });
        },

        // Limpiar perfil (útil al hacer logout)
        clearProfile: () => {
            set({ profile: null, error: null, isLoading: false });
        }
    }),
        { name: 'ProfileStore' }
    )
);
